import useTranslate from 'app/i18n/useTranslate';

const useConstants = () => {
    const t = useTranslate('navigation');

    return {
        ACCOUNT: t('account'),
        DATA: t('data'),
        HELP: t('help'),
        HOME: t('home'),
        MAINTENANCE: t('maintenance'),
        REPORTS: t('reports')
    };
};

export default useConstants;
